// Every "add" button looks the same (Kareem, 4 Nov): white with a thin border, black text, a plus. Black stays for the
// actions that commit (Save, Approve, Send, Add insight inside its form). One component, desktop and phone (on a
// phone it is 44px tall).
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { IconPlus } from './icons';

type Common = { children: ReactNode; className?: string; disabled?: boolean; title?: string; 'aria-label'?: string };

export function AddButton({ children, className = '', onClick, ...rest }: Common & { onClick: () => void }) {
  return <button type="button" className={`addb ${className}`.trim()} onClick={onClick} {...rest}><IconPlus />{children}</button>;
}

export function AddLink({ children, className = '', to }: Common & { to: string }) {
  return <Link className={`addb ${className}`.trim()} to={to}><IconPlus />{children}</Link>;
}
